import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JourneyLogContextService {
  private correlationIdSignal = signal<string | null>(null);

  getCorrelationId(): string | null {
    return this.correlationIdSignal();
  }

  setCorrelationId(correlationId: string | null): void {
    this.correlationIdSignal.set(correlationId);
  }

  clearCorrelationId(): void {
    this.correlationIdSignal.set(null);
  }

  getOrCreateCorrelationId(prefix = 'sys'): string {
    const current = this.correlationIdSignal();
    if (current) {
      return current;
    }

    const next = this.buildCorrelationId(prefix);
    this.correlationIdSignal.set(next);
    return next;
  }

  buildCorrelationId(prefix = 'jrny'): string {
    return `${prefix}-${this.formatUtcTimestamp()}-${this.randomSuffix(6)}`;
  }

  buildRequestId(): string {
    return `req-${this.randomSuffix(8)}`;
  }

  getRoute(): string {
    const path = window.location?.pathname;
    return path && path.length > 0 ? path : '/login';
  }

  getUserIdentity(): string {
    return localStorage.getItem('user_id') || 'UNKNOWN_USER';
  }

  private randomSuffix(length: number): string {
    const raw = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID().replace(/-/g, '')
      : Math.random().toString(16).slice(2);
    return raw.slice(0, length);
  }

  private formatUtcTimestamp(): string {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hour = String(now.getUTCHours()).padStart(2, '0');
    const minute = String(now.getUTCMinutes()).padStart(2, '0');
    const second = String(now.getUTCSeconds()).padStart(2, '0');
    return `${year}${month}${day}-${hour}${minute}${second}`;
  }
}
